export default {
    title: 'Lieferanten',
    name: 'Name',
    suppliers: 'Ansprechpersonen',
    recent_activity: 'Letzte Aktivität',
    noSuppliers: 'Keine Ansprechpersonen gefunden',
    external_access: 'Externer Zugriff',
    created_at: 'Erstellt am',
    status: 'Status',
    customFilterUserAccess: 'Zugang',
    customFilterUserEmails: 'Erhält Anfragen',
    qf_externalAccess: 'Mit Zugang zu BEMA',
    qf_externalMails: 'Erhält Anfragen',
}
